<div *ngIf="showMainImage && images[currentSlide]" class="position-relative">
    <img *ngIf="!images[currentSlide].competition" class="main-image hover" [src]="images[currentSlide].url"
        [appScrset]="images[currentSlide].url">
    <img *ngIf="images[currentSlide].competition" class="main-image hover" (click)="enterCompetition()"
        [src]="images[currentSlide].url" [appScrset]="images[currentSlide].url">

    <div *ngIf="discount > rewardDiscount && discount > 0" class="corner">
        <span>
            <svg-icon src="assets/images/discount_tag.svg" [svgClass]="'group-icon'"></svg-icon><br />
            -{{discount}}% off
        </span>
    </div>
    <div class="corner-trade" *ngIf="discount < rewardDiscount && rewardDiscount > 0">
        <div class="text-secondary">
            <div class="discount-text">
                Your Trade Discount:
            </div>
            <div class="price-tag-icon">
                <i class="fa fa-tags white-tag"></i>
            </div>
            <div class="percent-off">
                {{rewardDiscount}}% off
            </div>

        </div>
    </div>

</div>
<div class="navigation-wrapper px-3 px-md-0">
    <div class="keen-slider" #sliderRef>
        <div class="keen-slider__slide preview-tile d-flex align-items-center leigh"
            [ngClass]="{'active' : gi === currentSlide}" *ngFor="let pi of images; let gi = index; let first = first"
            (click)="this.selectSlide(pi, gi)">
            <img *ngIf="pi.url && !images[currentSlide].competition" class="image-as-bg hover" [src]="pi.url"
                [appScrset]="pi.url">

            <img *ngIf="pi.url && images[currentSlide].competition" class="image-as-bg hover"
                (click)="enterCompetition()" [src]="pi.url" [appScrset]="pi.url">

            <div *ngIf="(deviceType$| async) === 'desktop'" class="overlay"></div>
            <div *ngIf="discount > 0 && first && (deviceType$ |async) !== 'desktop'" class="corner">
                <span>
                    <svg-icon src="assets/images/discount_tag.svg" [svgClass]="'group-icon'"></svg-icon><br />
                    {{discount}}% off
                </span>
            </div>
        </div>
    </div>
    <ng-container *ngIf="(deviceType$| async) === 'desktop'">
        <button class="arrow__container arrow__container--left" (click)="slidePrev()"
            [ngClass]="{ 'arrow--disabled' : currentSlide === 0 }">
            <svg [style.fill]="arrowColour" focusable="false" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"
                class="svg-inline">
                <path
                    d="M136.97 380.485l7.071-7.07c4.686-4.686 4.686-12.284 0-16.971L60.113 273H436c6.627 0 12-5.373 12-12v-10c0-6.627-5.373-12-12-12H60.113l83.928-83.444c4.686-4.686 4.686-12.284 0-16.971l-7.071-7.07c-4.686-4.686-12.284-4.686-16.97 0l-116.485 116c-4.686 4.686-4.686 12.284 0 16.971l116.485 116c4.686 4.686 12.284 4.686 16.97-.001z">
                </path>
            </svg>
        </button>

        <button class="arrow__container arrow__container--right" (click)="slideNext()"
            [ngClass]="{'arrow--disabled': currentSlide === lastSlide}">
            <svg *ngIf="slider" [style.fill]="arrowColour" focusable="false" xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 448 512" class="svg-inline">
                <path
                    d="M311.03 131.515l-7.071 7.07c-4.686 4.686-4.686 12.284 0 16.971L387.887 239H12c-6.627 0-12 5.373-12 12v10c0 6.627 5.373 12 12 12h375.887l-83.928 83.444c-4.686 4.686-4.686 12.284 0 16.971l7.071 7.07c4.686 4.686 12.284 4.686 16.97 0l116.485-116c4.686-4.686 4.686-12.284 0-16.971L328 131.515c-4.686-4.687-12.284-4.687-16.97 0z">
                </path>
            </svg>
        </button>
    </ng-container>
</div>
<div class="dots py-4" *ngIf="showDots">
    <button (click)="slider.moveToSlideRelative(i)" *ngFor="let slide of dotHelper; let i = index"
        [class]="'dot ' + (i === currentSlide ? 'active' : '')"></button>
</div>